import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering of Entries within a single Playbook Chapter
// (card #4459). One instance per Chapter card -- same minimal fetch-PATCH
// shape as playbook_chapter_sortable_controller.js and
// album_image_sortable_controller.js.

export default class extends Controller {
  static targets = ["list"]
  static values = { url: String }

  connect() {
    if (!this.hasListTarget) return

    this._sortable = Sortable.create(this.listTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      chosenClass: "sortable-chosen-ring",
      forceFallback: true,
      fallbackOnBody: false,
      swapThreshold: 0.65,
      onEnd: () => this._persistOrder()
    })
  }

  disconnect() {
    this._sortable?.destroy()
    this._sortable = null
  }

  _persistOrder() {
    const rows = this.listTarget.querySelectorAll("[data-entry-id]")
    const entryIds = Array.from(rows).map(el => el.dataset.entryId).filter(Boolean)
    if (entryIds.length === 0 || !this.hasUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ entry_ids: entryIds })
    })
  }
}
